import React, { useState } from 'react';
import { PaletteIcon, FileTextIcon } from 'lucide-react';
export function OrderBumpSection() {
  const [isChecked, setIsChecked] = useState(false);
  const colorimetriaPrice = 6990;
  const colorimetriaPriceOriginal = 26990;
  return <section className="w-full bg-[#0a0a0a] py-8 md:py-16 px-4" data-id="element-134">
      <div className="max-w-4xl mx-auto" data-id="element-135">
        <div className="bg-[#111] border-l-8 border-[#c41e3a] rounded-lg p-6 md:p-10 shadow-xl" data-id="element-136">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 items-center" data-id="element-137">
            {/* Imagen */}
            <div className="flex justify-center" data-id="element-138">
              <img src="https://cdn.magicpatterns.com/uploads/rh3A2iQ4JRbSVg1yJuF5Ev/colorimetria.png" alt="Ebook de Colorimetría aplicada a barbería" className="w-56 md:w-72 rounded-xl shadow-2xl ring-2 ring-[#c41e3a]/30" data-id="element-139" />
            </div>

            {/* Contenido */}
            <div data-id="element-140">
              <div className="flex items-center gap-2 mb-2" data-id="element-141">
                <PaletteIcon className="w-5 h-5 text-[#c41e3a]" aria-hidden="true" data-id="element-142" />
                <p className="text-xs text-[#c41e3a] font-black tracking-widest uppercase" data-id="element-143">
                  Complemento opcional
                </p>
              </div>
              <h2 className="text-xl md:text-3xl font-black text-white mb-3 leading-tight" data-id="element-144">
                Sumá Colorimetría aplicada a barbería
              </h2>
              <p className="text-gray-400 text-sm md:text-base leading-relaxed mb-4" data-id="element-145">
                Mezclas, pigmentos, tiempos de exposición y resultados reales.
                Ideal para ampliar tus servicios y elevar tu nivel técnico.
              </p>

              {/* Formato incluido */}
              <div className="flex flex-col gap-2 mb-5" data-id="element-146">
                <div className="flex items-center gap-2 text-gray-300" data-id="element-147">
                  <FileTextIcon className="w-4 h-4 text-[#c41e3a] flex-shrink-0" aria-hidden="true" data-id="element-148" />
                  <span className="text-xs md:text-sm font-semibold" data-id="element-149">
                    Ebook profesional de 60 páginas (PDF descargable)
                  </span>
                </div>
                <div className="flex items-center gap-2 text-gray-300" data-id="element-150">
                  <svg className="w-4 h-4 text-[#c41e3a] flex-shrink-0" fill="none" viewBox="0 0 24 24" stroke="currentColor" aria-hidden="true" data-id="element-151">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14.752 11.168l-3.197-2.132A1 1 0 0010 9.87v4.263a1 1 0 001.555.832l3.197-2.132a1 1 0 000-1.664z" data-id="element-152" />
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 12a9 9 0 11-18 0 9 9 0 0118 0z" data-id="element-153" />
                  </svg>
                  <span className="text-xs md:text-sm font-semibold" data-id="element-154">
                    Material audiovisual de apoyo incluido
                  </span>
                </div>
              </div>

              {/* Checkbox */}
              <label className="flex items-start gap-3 cursor-pointer group bg-[#c41e3a]/8 p-4 md:p-5 rounded-lg border border-[#c41e3a]/30 hover:border-[#c41e3a] transition-all" data-id="element-155">
                <input type="checkbox" checked={isChecked} onChange={e => setIsChecked(e.target.checked)} className="w-5 h-5 mt-0.5 rounded border-2 border-gray-500 text-[#c41e3a] focus:ring-2 focus:ring-[#c41e3a] cursor-pointer flex-shrink-0" aria-label="Agregar formación en Colorimetría" data-id="element-156" />
                <div className="flex-1" data-id="element-157">
                  <span className="text-white text-sm md:text-base font-bold block mb-1" data-id="element-158">
                    🎨 Sí, quiero agregar Colorimetría
                  </span>
                  <div className="flex items-center gap-2" data-id="element-159">
                    <span className="text-gray-500 line-through text-sm font-semibold" data-id="element-160">
                      ${colorimetriaPriceOriginal.toLocaleString('es-AR')}
                    </span>
                    <span className="text-[#c41e3a] font-black text-xl" data-id="element-161">
                      +${colorimetriaPrice.toLocaleString('es-AR')}
                    </span>
                  </div>
                </div>
              </label>
            </div>
          </div>
        </div>
      </div>
    </section>;
}